import { Plan } from '../AdminCustomers/Customers';

interface PlanSelectorProps {
  allUserPlans: Plan[];
  handleSelectedPlan: (planId: string) => void;
  notUserOptionAllPlans?: boolean;
  useDemoModeOption?: boolean;
}

const PlanSelector: React.FC<PlanSelectorProps> = ({
                                                     allUserPlans,
                                                     handleSelectedPlan,
                                                     notUserOptionAllPlans,
                                                     useDemoModeOption,
                                                   }: PlanSelectorProps) => {
  return (
    <div className="flex items-center">
      <label htmlFor="plans" className="text-sm sm:text-base mr-2">
        Select Plan:
      </label>
      <select
        id="plans"
        className="p-2 border rounded-md text-sm sm:text-base"
        onChange={(e) => {
          const selectedPlan = e.target.value;
          handleSelectedPlan(selectedPlan);
        }}
      >
        <option value="" disabled selected>
          Select a Plan
        </option>
        {!notUserOptionAllPlans && <option value="">All Plans</option>}
        {useDemoModeOption && <option value="demo_mode">Demo mode</option>}
        {allUserPlans && allUserPlans.length > 0 ? (
          allUserPlans.map((plan, index) => (
            <option key={index} value={plan.id}>
              {plan.name}
            </option>
          ))
        ) : (
          <option>No plans available</option>
        )}
      </select>
    </div>
  );
};

export default PlanSelector;
